// components/LoadingIndicator.tsx - Reusable loading indicator component
import React from 'react';
import CroopLoader from './CroopLoader';

interface LoadingIndicatorProps {
  loadingSource: 'firebase' | 'local' | 'demo' | null;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ loadingSource }) => {
  const getLoadingMessage = () => {
    switch (loadingSource) {
      case 'firebase': return 'Loading video from Firebase Storage...';
      case 'local': return 'Loading your video file...';
      case 'demo': return 'Loading demo video...';
      default: return 'Loading...';
    }
  };

  const getLoadingSubtext = () => {
    switch (loadingSource) {
      case 'firebase': return 'This may take a moment for larger videos';
      case 'local': return 'Processing your upload';
      case 'demo': return 'Preparing demonstration features';
      default: return '';
    }
  };

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '16rem',
        width: '100%',
        backgroundColor: '#f3f4f6',
        borderRadius: '0.5rem'
      }}
    >
      <CroopLoader size={64} label="" className="croop-loading-indicator-logo" />
      <p style={{ color: '#6b7280', margin: 0, fontSize: '0.875rem' }}>
        {getLoadingMessage()}
      </p>
      <p style={{ color: '#9ca3af', margin: '0.5rem 0 0 0', fontSize: '0.75rem' }}>
        {getLoadingSubtext()}
      </p>
    </div>
  );
};

export default LoadingIndicator;
